/* tslint:disable */
export default {
	quizUrl: null,
	currentStep: 1,
	stepContainerSelector: ".waitingRoom-step",
	breakoutInterval: null,
	nextStepWaitingInterval: null,
	gameStartGracePeriodSeconds: pp.logEnabled ? 3 : 10, // For dev and staging
	storyStartGracePeriodSeconds: pp.logEnabled ? 1 : 20, // For dev and staging
	breakoutGracePeriodSeconds: 75,
	demoInactivityGracePeriodSeconds: 600, // 10 minutes
	autoSlideDuration: 7000,
	init(actorId, quizUrl, ownLaneTitle, minUsersToProgress) {
		pp.gameTokenLobby.attachedChangeHandleInitializers.push(
			// @ts-expect-error
			this.addListenerForUser,
		);
		// @ts-expect-error
		pp.gameTokenLobby.startGameHandler = this.startGameCountdown;

		this.minUsersToProgress = minUsersToProgress;
		pp.log("LOBBY minUsersToProgress:", this.minUsersToProgress);
		this.quizUrl = quizUrl;
		pp.gameTokenLobby.ownUserData.actorId = actorId;
		pp.gameTokenLobby.ownUserData.laneTitle = ownLaneTitle;

		this.observeChange("currentStep", this.handleStepChange);

		if (ownLaneTitle) {
			this.currentStep = 4;
		} else if (pp.gameTokenLobby.ownUserData.name) {
			this.currentStep = 2;
			// @ts-expect-error
		} else if (PrivatePub.state != PrivatePub.CONNECTED) {
			this.initPrivatePubStatusObserver();
		}

		$("#j-reset-game-link").attr(
			"href",
			`/game_tokens/${pp.gameTokenLobby.gameToken}/reset_actors`,
		);

		$(document).on("click", ".j-start-quiz", this.startQuiz);
		$(document).on("click", ".j-next-slide", function (e) {
			e.preventDefault();
			e.stopPropagation();
			pp.waitingRoom.showNextSlideInContainer(
				$(this).parents(".slider-fullscreen"),
			);
		});
	},

	addListenerForUser(userId) {
		pp.gameTokenLobby.userData.observeChange(userId, function (oldval, newval) {
			pp.waitingRoom.handleLobbyUserDataChange(userId, oldval, newval);
		});
		// trigger once now
		pp.waitingRoom.handleLobbyUserDataChange(
			userId,
			null,
			pp.gameTokenLobby.userData[userId],
		);
	},

	handleLobbyUserDataChange(userId, oldval, newval) {
		// pp.log("handleLobbyUserDataChange in WR", userId, oldval, newval);
		if (newval) {
			if (
				newval.lastSeen &&
				this.breakoutInterval &&
				(!oldval || !oldval.lastSeen)
			) {
				// not all are online but something is happening, so reset countdown
				// pp.log("newly online", userId);
				pp.waitingRoom.initBreakoutInterval();
			}

			if (newval.quizCompletedWithLane) {
				if (!oldval || !oldval.quizCompletedWithLane) {
					if (
						parseInt(userId) === pp.gameTokenLobby.ownUserData.id &&
						pp.gameTokenLobby.usersWithPropertyCount(
							"quizCompletedWithLane",
							"!==",
							null,
						) >= this.minUsersToProgress &&
						pp.gameTokenLobby.usersWithPropertyCount(
							"quizCompletedWithLane",
							"!==",
							undefined,
						) >= this.minUsersToProgress
					) {
						// pp.log("completed", userId, pp.gameTokenLobby.ownUserData.id, pp.gameTokenLobby.usersWithPropertyCount('quizCompletedWithLane', '!==', null));
						$.post(`/game_tokens/${pp.gameTokenLobby.gameToken}/start_game`);
					} else if (pp.waitingRoom.breakoutInterval) {
						// Not all are online but something is happening, so reset countdown
						pp.waitingRoom.initBreakoutInterval();
					}
				}
			}
			if (newval.actorId) {
				// pp.log("has actor id", newval);
				$(`#j-actor-${newval.actorId}`).attr(
					"data-lobby-status-for-user-id",
					userId,
				);
				$(`#j-actor-${newval.actorId}-status`)
					.find("span.actorsBadgeList-userName")
					.attr("data-lobby-name-for-user-id", userId);
				$(`#j-actor-${newval.actorId}-status`)
					.find(".actorsBadgeList-laneName")
					.attr("data-lobby-quiz-lane-for-user-id", userId);
				$(
					`#j-actor-${newval.actorId}-status div.j-quiz-completion-status-message`,
				).attr("data-lobby-quiz-status-for-user-id", userId);
			}
		}

		this.setStateChangeMessage(
			`<div class='onlinePlayerCount'>${pp.gameTokenLobby.usersWithPropertyCount("name", "!==", null)}/${$("li.actor").length} Spieler online</div>\
			<div class='instructionalNote'>Wartet auf weitere Spieler…</div>`,
		);

		// Show story if the minimum number of waiting Users has been reached and if this user is not already past the story slides (`startStoryCountdown` will go to step 3)
		if (
			pp.gameTokenLobby.usersWithPropertyCount("name", "!==", null) >=
				this.minUsersToProgress &&
			this.currentStep == 2
		) {
			this.startStoryCountdown();
		}
	},

	setStoryImages(gender) {
		$("div[data-gender]").addClass("hidden"); // in case there were slides visible before somehow
		$(`div[data-gender=${gender}]`).removeClass("hidden");
	},

	initPrivatePubStatusObserver() {
		const $nameAndGenderForm = $("div.waitingRoom-step").first();
		const $nameAndGenderFormBtn = $nameAndGenderForm.find(
			"form input.ulab-button",
		);

		$nameAndGenderForm.find("form input").prop("disabled", true);
		// @ts-expect-error
		$nameAndGenderFormBtn.data("stored-val", $nameAndGenderFormBtn.val());
		$nameAndGenderFormBtn.val("Warte auf Verbindung…");
		pp.waitingRoom.initBreakoutInterval();
		// @ts-expect-error
		PrivatePub.observeChange("state", function (oldval, newval) {
			// @ts-expect-error
			if (newval == PrivatePub.CONNECTED) {
				pp.waitingRoom.clearBreakoutInterval();
				$nameAndGenderForm.find("form input").prop("disabled", false);
				$nameAndGenderFormBtn.val($nameAndGenderFormBtn.data("stored-val"));
			}
		});
	},

	handleStepChange() {
		pp.log("LOBBY showing step -- step", this.currentStep);

		if (this.currentStep == 2) {
			this.autoSlideInterval = window.setInterval(() => {
				this.showNextSlideInContainer($("#waiting-room-1"));
			}, this.autoSlideDuration);
		} else if (this.autoSlideInterval) {
			window.clearInterval(this.autoSlideInterval);
			this.autoSlideInterval = null;
		}
		$(this.stepContainerSelector).addClass("hide");
		$(this.stepContainerSelector)
			.eq(this.currentStep - 1)
			.removeClass("hide")
			.addClass("animated animated-speed-medium fadeIn");
		this.initBreakoutInterval();
	},

	startInterval(seconds, callback) {
		if (this.nextStepWaitingInterval) return;

		pp.waitingRoom.clearBreakoutInterval();
		$("#countdown-text").text("weiter in: ");
		$("#countdown-time").html(
			`<span id='j-countdown-time-count'>${seconds}</span>`,
		);
		// @ts-expect-error
		this.nextStepWaitingInterval = window.setInterval(() => {
			seconds--;
			$("#j-countdown-time-count").text(seconds.toString());
			if (seconds == 0) {
				// @ts-expect-error
				window.clearInterval(this.nextStepWaitingInterval);
				this.nextStepWaitingInterval = null;
				$("#countdown-text, #countdown-time").html("");
				callback();
			}
		}, 1000);
	},

	startStoryCountdown() {
		this.setStateChangeMessage("Alle Spieler online!");
		let i = this.storyStartGracePeriodSeconds;
		this.startInterval(i, function () {
			pp.waitingRoom.currentStep = 3;
		});
	},

	startGameCountdown() {
		clearInterval(pp.waitingRoom.demoInactivityInterval);
		clearInterval(pp.gameTokenLobby.lobbyStatusObserver);
		pp.waitingRoom.demoInactivityInterval = null;
		let i = pp.waitingRoom.gameStartGracePeriodSeconds;
		pp.waitingRoom.setStateChangeMessage("Alle haben das Quiz beantwortet.");
		pp.waitingRoom.startInterval(i, function () {
			window.location.replace("/");
		});
	},

	startQuiz(event) {
		// pp.log("STARTING QUIZ");
		event.preventDefault();
		pp.waitingRoom.currentStep = 4;
		$(document).on(
			"hide.bs.modal",
			"#quiz-modal",
			pp.waitingRoom.notifyQuizCompletion,
		);

		const $statusMessage = $(
			`#j-actor-${pp.gameTokenLobby.ownUserData.actorId}-status div.j-quiz-completion-status-message`,
		);
		$statusMessage.html("Lade Quiz…");
		// @ts-expect-error
		$.ajax({
			url: pp.waitingRoom.quizUrl,
			type: "GET",
			tryCount: 0,
			retryLimit: 3,
			timeout: 5000,
			success: function (data) {
				$("#quiz-modal .modal-content").html(data);
				$("#quiz-modal").addClass("unionslabor-quiz");
				$("#quiz-modal").modal("show");
				pp.waitingRoom.clearBreakoutInterval();
			},
			error: function (xhr, textStatus, errorThrown) {
				if (textStatus == "timeout") {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						$.ajax(this); // try again
						$statusMessage.html(`Lade Quiz (${this.tryCount + 1})…`);
					} else {
						$statusMessage.html(
							"Laden des Quizzes fehlgeschlagen.<br>Bitte Seite neuladen!",
						);
					}
				}
			},
		});
	},

	notifyQuizCompletion() {
		pp.gameTokenLobby.sendViaPrivatePub({
			quizCompletedById: pp.gameTokenLobby.ownUserData.id,
			laneTitle: pp.gameTokenLobby.ownUserData.laneTitle,
		});
		pp.waitingRoom.initBreakoutInterval();
	},

	setStateChangeMessage(html) {
		$(".state-change-message").html(html);
	},

	initBreakoutInterval() {
		// pp.log("LOBBY initBreakoutInterval");
		pp.waitingRoom.clearBreakoutInterval();

		let i = this.breakoutGracePeriodSeconds;
		// @ts-expect-error
		this.breakoutInterval = window.setInterval(function () {
			// pp.log("LOBBY breakoutInverval step", i);
			if (i == 0) {
				$("#unionslabor-breakout-modal").modal("show");
				// this means that the user has dismissed the modal, so start the countdown again
				$("#unionslabor-breakout-modal").one("hidden.bs.modal", function () {
					pp.waitingRoom.initBreakoutInterval();
				});
				pp.waitingRoom.clearBreakoutInterval();
			}
			i--;
		}, 1000);
	},

	clearBreakoutInterval() {
		// pp.log("clearing");
		if ($("#unionslabor-breakout-modal").hasClass("in"))
			$("#unionslabor-breakout-modal").modal("hide");
		if (!this.breakoutInterval) return;
		clearInterval(this.breakoutInterval);
		this.breakoutInterval = null;
	},

	initDemoInactivityInterval() {
		pp.log("LOBBY initDemoInactivityInterval");

		let i = pp.waitingRoom.demoInactivityGracePeriodSeconds;
		pp.waitingRoom.demoInactivityInterval = window.setInterval(function () {
			// pp.log("LOBBY initDemoInactivityInterval step", i);
			$("#j-inactivity-seconds-countdown").text(i);
			if (i == 20) {
				$("#unionslabor-demo-inactivity-modal").modal("show");
			}
			if (i == 0) {
				window.location.replace("/users/logout?reason=demoInactivity");
				clearInterval(pp.waitingRoom.demoInactivityInterval);
			}

			i--;
		}, 1000);
	},

	showNextSlideInContainer($sliderContainer) {
		const $currentSlide = $sliderContainer.find(
			".slider-fullscreen-slide:not(.hide):not(.animated)",
		);
		if ($currentSlide.length == 0) {
			// means that there is a transition going on right now
			// pp.log("no current slide");
			return;
		}
		let $nextSlide = $currentSlide.next(".slider-fullscreen-slide");
		if ($nextSlide.length == 0) {
			// pp.log("did not find next slide (might be because the current slide is the last in container), getting:",
			// 	$sliderContainer.find('.slider-fullscreen-slide:first-child'));
			$nextSlide = $sliderContainer.find(
				".slider-fullscreen-slide:first-child",
			);
		}
		// pp.log("current, next", $currentSlide, $nextSlide);
		$nextSlide
			.removeClass("slideOutLeft")
			.removeClass("slideInRight")
			.removeClass("animated animated-speed-fast");
		$currentSlide.addClass("animated animated-speed-fast slideOutLeft");
		$nextSlide
			.removeClass("hide")
			.addClass("animated animated-speed-fast slideInRight");
		window.setTimeout(function () {
			$currentSlide
				.addClass("hide")
				.removeClass("animated animated-speed-fast slideInRight slideOutLeft");
			$nextSlide.removeClass("animated animated-speed-fast slideInRight");
		}, 350);
	},
};
